import axios from "axios";

const getPayoutList = async (idToken, params) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
      params,
    };
    const response = await axios.get("user/payout/list/", config);
    return response.data;
  } catch (error) {
    console.error("Error during PayoutList request:", error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
};
const getPfsPayoutList = async (idToken) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.get("user/payout/accounts/", config);
    return response.data;
  } catch (error) {
    console.error("Error during PFS request:", error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
};
const getAfsPayoutList = async (idToken) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.get("user/eligible-commission/", config);
    return response.data;
  } catch (error) {
    console.error("Error during AFS request:", error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
};
const requestPayouts = async (idToken, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.post("user/payout/request/", data, config);
    return response;
  } catch (error) {
    console.error("Error during AFS request:", error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
};
const alphaCreator = async (idToken, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    };
    const response = await axios.post(
      "user/alpha-creator/request/",
      data,
      config
    );
    return response;
  } catch (error) {
    console.error("Error during alphaCreator request:", error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
};
const getAffiliateStats = async (idToken, params = {}) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
      params,
    };
    const response = await axios.get("affiliates/affiliate-stats/", config);
    return response;
  } catch (error) {
    console.error("Error during affiliate-stats request:", error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
};

const getAffiliateList = async (idToken, params) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
      params,
    };
    const response = await axios.get("affiliates/list/", config);
    return response;
  } catch (error) {
    console.error("Error during affiliates/list/ request:", error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
};

const getRiseDetails = async (idToken) => {
  let config = {
    headers: { Authorization: `Bearer ${idToken}` },
  };
  try {
    const res = await axios.get(`user/api/rise/`, config);
    if (res?.response?.status > 399) {
      return {};
    }
    return res.data;
  } catch (err) {
    throw err;
  }
};
const getAllBankDetails = async (idToken) => {
  let config = {
    headers: { Authorization: `Bearer ${idToken}` },
  };
  try {
    const res = await axios.get(`user/api/payment-details/`, config);
    if (res?.response?.status > 399) {
      return {};
    }
    return res.data;
  } catch (err) {
    throw err;
  }
};
const addAllBanks = async (idToken, data, path) => {
  let config = {
    headers: { Authorization: `Bearer ${idToken}` },
  };
  const output = await axios
    .post(`user/api/${path}/`, data, config)
    .then((res) => {
      return res;
    })
    .catch(function (error) {
      return error;
    });
  return output;
};

export {
  getPayoutList,
  getPfsPayoutList,
  getAfsPayoutList,
  requestPayouts,
  getAffiliateStats,
  getAffiliateList,
  getRiseDetails,
  addAllBanks,
  getAllBankDetails,
  alphaCreator,
};
